"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const TabbedComponent_1 = __importDefault(require("@mwater/react-library/lib/TabbedComponent"));
const uiComponents = __importStar(require("../UIComponents"));
const expressions_1 = require("@mwater/expressions");
const MWaterCustomTablesetListComponent_1 = require("./MWaterCustomTablesetListComponent");
const MWaterMetricsTableListComponent_1 = require("./MWaterMetricsTableListComponent");
const MWaterAssetSystemsListComponent_1 = require("./MWaterAssetSystemsListComponent");
const FormsListComponent_1 = require("./FormsListComponent");
const IndicatorsListComponent_1 = require("./IndicatorsListComponent");
const IssuesListComponent_1 = require("./IssuesListComponent");
const MWaterAccountingSystemListComponent_1 = require("./MWaterAccountingSystemListComponent");
const sitesOrder = {
    "entities.water_point": 1,
    "entities.sanitation_facility": 2,
    "entities.household": 3,
    "entities.community": 4,
    "entities.school": 5,
    "entities.health_facility": 6,
    "entities.place_of_worship": 7,
    "entities.water_system": 8,
    "entities.water_system_component": 9,
    "entities.wastewater_treatment_system": 10,
    "entities.waste_disposal_site": 11
};
/** Entity types that are assets */
const assetEntities = [
    "entities.water_asset"
];
// Allows selection of a table. Is the complete list mode of tables
class MWaterCompleteTableSelectComponent extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLegacyAssets: false
        };
    }
    handleExtraTableAdd = (tableId) => {
        return this.props.onExtraTablesChange(lodash_1.default.union(this.props.extraTables, [tableId]));
    };
    handleExtraTableRemove = (tableId) => {
        // Set to null if current table
        if (this.props.table === tableId) {
            this.props.onChange(null);
        }
        return this.props.onExtraTablesChange(lodash_1.default.without(this.props.extraTables, tableId));
    };
    renderSites() {
        let table;
        let types = [];
        for (table of this.props.schema.getTables()) {
            if (table.deprecated) {
                continue;
            }
            if (!table.id.match(/^entities\./)) {
                continue;
            }
            // Skip assets
            if (assetEntities.includes(table.id)) {
                continue;
            }
            types.push(table.id);
        }
        // Sort by order if present
        types = lodash_1.default.sortBy(types, (type) => sitesOrder[type] || 999);
        return react_1.default.createElement(uiComponents.OptionListComponent, { items: lodash_1.default.compact(lodash_1.default.map(types, (tableId) => {
                table = this.props.schema.getTable(tableId);
                return {
                    name: expressions_1.ExprUtils.localizeString(table.name, T.locale),
                    desc: expressions_1.ExprUtils.localizeString(table.desc, T.locale),
                    onClick: this.props.onChange.bind(null, table.id)
                };
            })) });
    }
    renderForms() {
        return react_1.default.createElement(FormsListComponent_1.FormsListComponent, { schema: this.props.schema, client: this.props.client, apiUrl: this.props.apiUrl, user: this.props.user, onChange: this.props.onChange, extraTables: this.props.extraTables, onExtraTableAdd: this.handleExtraTableAdd, onExtraTableRemove: this.handleExtraTableRemove });
    }
    renderIndicators() {
        return react_1.default.createElement(IndicatorsListComponent_1.IndicatorsListComponent, { schema: this.props.schema, client: this.props.client, apiUrl: this.props.apiUrl, user: this.props.user, onChange: this.props.onChange, extraTables: this.props.extraTables, onExtraTableAdd: this.handleExtraTableAdd, onExtraTableRemove: this.handleExtraTableRemove });
    }
    renderIssues() {
        return react_1.default.createElement(IssuesListComponent_1.IssuesListComponent, { schema: this.props.schema, client: this.props.client, apiUrl: this.props.apiUrl, user: this.props.user, onChange: this.props.onChange, extraTables: this.props.extraTables, onExtraTableAdd: this.handleExtraTableAdd, onExtraTableRemove: this.handleExtraTableRemove });
    }
    renderSweetSense() {
        let sweetSenseTables = this.getSweetSenseTables();
        sweetSenseTables = lodash_1.default.sortBy(sweetSenseTables, (table) => table.name.en);
        return react_1.default.createElement(uiComponents.OptionListComponent, { items: lodash_1.default.map(sweetSenseTables, (table) => {
                return {
                    name: expressions_1.ExprUtils.localizeString(table.name, T.locale),
                    desc: expressions_1.ExprUtils.localizeString(table.desc, T.locale),
                    onClick: this.props.onChange.bind(null, table.id)
                };
            }) });
    }
    renderTablesets() {
        return react_1.default.createElement(MWaterCustomTablesetListComponent_1.MWaterCustomTablesetListComponent, { schema: this.props.schema, client: this.props.client, apiUrl: this.props.apiUrl, user: this.props.user, onChange: this.props.onChange, extraTables: this.props.extraTables, onExtraTableAdd: this.handleExtraTableAdd, onExtraTableRemove: this.handleExtraTableRemove, locale: T.locale });
    }
    renderMetrics() {
        return react_1.default.createElement(MWaterMetricsTableListComponent_1.MWaterMetricsTableListComponent, { schema: this.props.schema, client: this.props.client, apiUrl: this.props.apiUrl, user: this.props.user, onChange: this.props.onChange, extraTables: this.props.extraTables, onExtraTableAdd: this.handleExtraTableAdd, onExtraTableRemove: this.handleExtraTableRemove, locale: T.locale });
    }
    renderAccountingSystems() {
        return react_1.default.createElement(MWaterAccountingSystemListComponent_1.MWaterAccountingSystemListComponent, { schema: this.props.schema, client: this.props.client, apiUrl: this.props.apiUrl, user: this.props.user, onChange: this.props.onChange, extraTables: this.props.extraTables, onExtraTableAdd: this.handleExtraTableAdd, onExtraTableRemove: this.handleExtraTableRemove, locale: T.locale });
    }
    renderAssets() {
        const items = [];
        for (const tableId of assetEntities) {
            const table = this.props.schema.getTable(tableId);
            if (!table) {
                continue;
            }
            items.push({
                name: expressions_1.ExprUtils.localizeString(table.name, T.locale),
                desc: expressions_1.ExprUtils.localizeString(table.desc, T.locale),
                onClick: this.props.onChange.bind(null, table.id),
                onRemove: this.handleExtraTableRemove.bind(null, table.id)
            });
        }
        return react_1.default.createElement("div", null,
            react_1.default.createElement(uiComponents.OptionListComponent, { items: items }),
            react_1.default.createElement("div", { className: "text-center mt-2 mb-2" },
                react_1.default.createElement("button", { className: "btn btn-link", onClick: () => this.setState({ showLegacyAssets: !this.state.showLegacyAssets }) },
                    this.state.showLegacyAssets ? T `Hide` : T `Show`,
                    " ",
                    T `Legacy Assets`)),
            this.state.showLegacyAssets && this.renderLegacyAssets());
    }
    renderLegacyAssets() {
        return react_1.default.createElement(MWaterAssetSystemsListComponent_1.MWaterAssetSystemsListComponent, { schema: this.props.schema, client: this.props.client, apiUrl: this.props.apiUrl, user: this.props.user, onChange: this.props.onChange, extraTables: this.props.extraTables, onExtraTableAdd: this.handleExtraTableAdd, onExtraTableRemove: this.handleExtraTableRemove, locale: T.locale });
    }
    renderOther() {
        let otherTables = lodash_1.default.filter(this.props.schema.getTables(), (table) => {
            // Remove deprecated
            if (table.deprecated) {
                return false;
            }
            // Remove sites
            if (table.id.match(/^entities\./)) {
                return false;
            }
            // sweetsense tables
            if (table.id.match(/^sweetsense/)) {
                return false;
            }
            // Remove responses
            if (table.id.match(/^responses:/)) {
                return false;
            }
            // Remove indicators
            if (table.id.match(/^indicator_values:/)) {
                return false;
            }
            // Remove issues
            if (table.id.match(/^(issues|issue_events):/)) {
                return false;
            }
            // Remove custom tablesets
            if (table.id.match(/^custom\./)) {
                return false;
            }
            // Remove metrics
            if (table.id.match(/^metrics:/)) {
                return false;
            }
            // Remove assets
            if (table.id.match(/^assets:/)) {
                return false;
            }
            return true;
        });
        otherTables = lodash_1.default.sortBy(otherTables, (table) => table.name.en);
        return react_1.default.createElement(uiComponents.OptionListComponent, { items: lodash_1.default.map(otherTables, (table) => {
                return {
                    name: expressions_1.ExprUtils.localizeString(table.name, T.locale),
                    desc: expressions_1.ExprUtils.localizeString(table.desc, T.locale),
                    onClick: this.props.onChange.bind(null, table.id)
                };
            }) });
    }
    getSweetSenseTables() {
        return lodash_1.default.filter(this.props.schema.getTables(), (table) => {
            if (table.deprecated) {
                return false;
            }
            if (table.id.match(/^sweetsense/)) {
                return true;
            }
            return false;
        });
    }
    render() {
        const sweetSenseTables = this.getSweetSenseTables();
        const tabs = [
            { id: "sites", label: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("i", { className: "fa fa-map-marker" }),
                    " ",
                    T `Sites`), elem: this.renderSites() },
            { id: "forms", label: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("i", { className: "fa fa-th-list" }),
                    " ",
                    T `Surveys`), elem: this.renderForms() },
            {
                id: "indicators",
                label: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("i", { className: "fa fa-check-circle" }),
                    " ",
                    T `Indicators`),
                elem: this.renderIndicators()
            },
            {
                id: "issues",
                label: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("i", { className: "fa fa-exclamation-circle" }),
                    " ",
                    T `Issues`),
                elem: this.renderIssues()
            },
            { id: "tablesets", label: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("i", { className: "fa fa-table" }),
                    " ",
                    T `Tables`), elem: this.renderTablesets() },
            { id: "metrics", label: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("i", { className: "fa fa-line-chart" }),
                    " ",
                    T `Metrics`), elem: this.renderMetrics() },
            {
                id: "accounting",
                label: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("i", { className: "fa fa-calculator" }),
                    " ",
                    T `Accounting`),
                elem: this.renderAccountingSystems()
            },
            { id: "assets", label: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("i", { className: "fas fa-map-pin" }),
                    " ",
                    T `Assets`), elem: this.renderAssets() }
        ];
        if (sweetSenseTables.length > 0) {
            tabs.push({ id: "sensors", label: T `Sensors`, elem: this.renderSweetSense() });
        }
        tabs.push({ id: "other", label: T `Advanced`, elem: this.renderOther() });
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "text-muted" }, T `Select data from sites, surveys or an advanced category below. Indicators can be found within their associated site types.`),
            react_1.default.createElement(TabbedComponent_1.default, { tabs: tabs, initialTabId: "sites" })));
    }
}
exports.default = MWaterCompleteTableSelectComponent;
